import { render, staticRenderFns } from "./ActionAlimiBasic.vue?vue&type=template&id=658486ee&"
import script from "./ActionAlimiBasic.vue?vue&type=script&lang=js&"
export * from "./ActionAlimiBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports